var _circle, _path, _g, _path2, _line, _ellipse, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse2, _ellipse3, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 241,
    viewBox: "0 0 329 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121.844,
    cy: 120.5,
    r: 120.5,
    fill: "#D7F1DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3435 83.5L148.344 76L311.344 99L215.844 113L51.3435 83.5Z",
    fill: "#716F6F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2894_8364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3435 129V84L215.844 113.5L313.344 99V146.5L215.844 166.5L51.3435 129Z",
    fill: "url(#paint0_linear_2894_8364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3435 129V84L215.844 113.5L313.344 99V146.5L215.844 166.5L51.3435 129Z",
    stroke: "#999999"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.844 126.5V113L161.344 121.5V135.5L114.844 126.5Z",
    fill: "#A9A9A9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 216.344,
    y1: 113,
    x2: 216.344,
    y2: 166,
    stroke: "#3C3636"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.174,
    cy: 134.383,
    rx: 2.27507,
    ry: 2.3291,
    transform: "rotate(1.37279 203.174 134.383)",
    fill: "#00A3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9435 114.917V107.12L84.7435 108.583V116.38L76.9435 114.917Z",
    fill: "#414141",
    stroke: "#D9D9D9",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.944 133.917V126.12L178.744 127.583V135.38L170.944 133.917Z",
    fill: "#414141",
    stroke: "#D9D9D9",
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182.944 135.917V128.12L190.744 129.583V137.38L182.944 135.917Z",
    fill: "#414141",
    stroke: "#D9D9D9",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.994 123.876V116.181L125.694 117.624V125.319L117.994 123.876Z",
    fill: "#414141",
    stroke: "#D9D9D9",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.994 125.876V118.181L136.694 119.624V127.319L128.994 125.876Z",
    fill: "#414141",
    stroke: "#D9D9D9",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.994 127.876V120.181L147.694 121.624V129.319L139.994 127.876Z",
    fill: "#414141",
    stroke: "#D9D9D9",
    strokeWidth: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.994 129.876V122.181L158.694 123.624V131.319L150.994 129.876Z",
    fill: "#414141",
    stroke: "#D9D9D9",
    strokeWidth: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4238 105L64.8433 105.5L65.8433 113L69.8433 112C71.3433 110 70.9238 105.5 68.4238 105Z",
    fill: "#7E8281"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.772,
    cy: 109.228,
    rx: 2.41257,
    ry: 3.93529,
    transform: "rotate(-4.19758 65.772 109.228)",
    fill: "#D9D9D9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.7168,
    cy: 109.252,
    rx: 1.9,
    ry: 3.4043,
    transform: "rotate(-4.19757 65.7168 109.252)",
    fill: "#A4A0A0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.844 112.317L102.844 112V119.962L104.844 120.317V112.317Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9",
    strokeWidth: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5555 112.417L90.5555 110.121L98.2435 111.583L98.2436 113.879L90.5555 112.417Z",
    fill: "#4485D1",
    stroke: "#CAC5C5",
    strokeWidth: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5555 117.555L90.5555 115.258L98.2435 116.72L98.2436 119.017L90.5555 117.555Z",
    fill: "#4485D1",
    stroke: "#CAC5C5",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2894_8364",
    x: 45.8435,
    y: 83.4023,
    width: 283,
    height: 103.609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.493507 0 0 0 0 0.508333 0 0 0 0 0.50648 0 0 0 0.39 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2894_8364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2894_8364",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2894_8364",
    x1: 95.3435,
    y1: 139,
    x2: 327.344,
    y2: 150.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44313,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABAB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceGuide);
export default __webpack_public_path__ + "static/media/device-guide.6e3af38cf6bee547a1675da0542fb821.svg";
export { ForwardRef as ReactComponent };